<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">Client Notes</h4>
  <button
    cpGTagEvent
    [params]="{ event_label: 'client_notes_modal_dismiss' }"
    type="button"
    class="close"
    aria-label="Close"
    (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="d-flex justify-content-end mb-2">
    <a target="_blank" routerLink="/client/{{ clientCode }}/notes">
      Open Client Notes Page&nbsp;<i class="fas fa-external-link-alt"></i>
    </a>
  </div>
  <ng-container *ngIf="clientNote && clientNote.Note; then displayNote; else noNote">
  </ng-container>
  <ng-template #displayNote>
    <div class="pre">{{ clientNote.Note }}</div>
  </ng-template>
  <ng-template #noNote>
    <em>No client note to display</em>
  </ng-template>
</div>
